module.exports = __webpack_public_path__ + "img/materialise1.df1a8d5c.png";